/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export function arrayToObject(arr, key) {
    return arr.reduce((obj, item) => {
        obj[item[key]] = item;
        return obj;
    }, {});
}
export function arrayTail(arr) {
    return arr.length ? arr[arr.length - 1] : void 0;
}
export function arrayHead(arr) {
    return arr.length ? arr[0] : void 0;
}
export function previousInArray(current, arr) {
    const idx = arr.indexOf(current);
    return idx === -1 ? void 0 : arr[Math.max(idx - 1, 0)];
}
export function nextInArray(current, arr) {
    const idx = arr.indexOf(current);
    return idx === -1 ? void 0 : arr[Math.min(idx + 1, arr.length - 1)];
}
export function arrayRemoveFirstInstance(val, arr) {
    const newArr = Array.from(arr);
    const i = arr.indexOf(val);
    if (i > -1) {
        newArr.splice(i, 1);
    }
    return newArr;
}
export function arrayRemoveLastInstance(val, arr) {
    const reversedArr = Array.from(arr).reverse();
    return arrayRemoveFirstInstance(val, reversedArr).reverse();
}
export function arrayRemoveAllInstances(val, arr) {
    const arrayRemovalMachine = [].concat(val);
    return arr.filter(item => !arrayRemovalMachine.includes(item));
}
export function groupArray(arr, size) {
    return [...arr].reduce((acc, val, i) => {
        const idx = Math.floor(i / size);
        const page = acc[idx] || (acc[idx] = []);
        page.push(val);
        return acc;
    }, []);
}
export async function* asyncGroupArray(items, batch = 100) {
    const values = groupArray(items, batch);
    for (let i = 0; i < values.length; i++) {
        yield values[i];
        await new Promise(r => setTimeout(r, 0));
    }
}
